import React from 'react';

import { connect } from 'react-redux';
import { contentChange } from '../../../actions/content';
import { logoutPrepare } from '../../../actions/login';
import { GfdbLogo } from '../../atoms/Logos';
import ReactTimeout from 'react-timeout';

var AppConfig = require('../../../config.json');

/**
 * A simple Footer.
 */

const getLink = (itm, n) => <li key={`externallink_${n}`}><a href={itm.url} target="_blank">{itm.label}</a></li>;

class Footer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { windowWidth: 0, windowHeight: 0, bodyHeight: 0, init: false,rollout: false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
    this.revealFooter = this.revealFooter.bind(this);
    this.rollIn = this.rollIn.bind(this);
    this.logoutClick = this.logoutClick.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    this.props.setTimeout(this.revealFooter, 500);
    window.addEventListener('resize', this.updateWindowDimensions);
  }

 
  componentWillUpdate(nextProps, nextState) {
    if(this.props.pathname!==nextProps.pathname && this.state.rollout && nextState.rollout) {
      this.props.setTimeout(this.updateWindowDimensions, 300);
      this.scrollUp();
    }
     if(this.props.contentChange!==nextProps.contentChange && !this.state.rollout && !nextState.rollout) {
      
      this.setState({ rollout: true });
      
    }
  }
  revealFooter() {
    this.setState({ init: true });
    this.updateWindowDimensions();
  }

  scrollUp() {
     window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    var height = parseInt(document.getElementById("wrapper").offsetHeight, 10);
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight, bodyHeight: height });
     this.props.setTimeout(this.rollIn, 100);
  }
  rollIn() {
    this.setState({ rollout: false });
  }

  logoutClick() {
    this.props.dispatch(logoutPrepare());
    this.props.dispatch(contentChange('logout'));
  }

  getFooterClass() {
    let className = this.props.isAuthenticated?"isauth":"";
    if(this.state.windowHeight>this.state.bodyHeight+130) {
      className += " fixed";
    }
    if(this.state.init && !this.state.rollout) {
      className += " reveal";
    }
    if(this.state.rollout) {
      className += " rollout";
    }
    return className;
  }

  render() {

    return (
      <div id="footer" className={this.getFooterClass()}>
          <div>
            {this.props.isAuthenticated && <div className="pricehint">
              {
                AppConfig.footerPriceHint
              }
            </div>}
              <div className="footerinner">
                <div className="footerlogo">
                  {/*<GfdbLogo />*/}
                </div>
                  <ul>
                  {
                    AppConfig.footer.map((itm,n) => getLink(itm,n))
                  }
                    {this.props.isAuthenticated?
                    <li><span onClick={this.logoutClick}>Logout</span></li>
                    :null}
                  </ul>
              </div>
              <div className="footerlegal">
                  <ul>
                  {
                    AppConfig.footerlegal.map((itm,n) => getLink(itm,n))
                  }
                  </ul>
              </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    pathname: state.routing.location.pathname,
    contentChange: state.content.link,
    isAuthenticated: state.auth.isAuthenticated
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(Footer))



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/Footer.js